import Caption from '@zenbusiness/common-components/Caption';
import SharedAsset from '@zenbusiness/common-components/SharedAsset';
import Text from '@zenbusiness/common-components/Text';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import WatchLaterIcon from '@mui/icons-material/WatchLater';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

import superstyled, { superstyledWithRef } from '#client/pages/EducationStudio/utils/superstyled';

export const LessonCardContainer = superstyledWithRef({
  tag: Box,
  styles: ({ theme }) => ({
    borderStyle: 'solid',
    borderWidth: '1px 3px 3px 1px',
    borderRadius: '0.75rem',
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',

    width: '16.5rem',
    minWidth: '16.5rem',

    [theme.breakpoints.up('md')]: {
      width: '20.5rem',
      minWidth: '20.5rem'
    }
  })
});

export const LessonImage = superstyled({
  tag: SharedAsset,
  propsNeeded: ['isCompleted'],
  styles: ({ theme, isCompleted }) => ({
    borderRadius: '0.75rem 0.75rem 0 0',
    borderBottom: `1px solid ${theme.palette.focus90.main}`,
    width: '100%',
    opacity: isCompleted ? '0.5' : '1'
  })
});

export const CardBottom = superstyled({
  tag: Box,
  styles: {
    padding: '1rem',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }
});

export const Title = superstyled({
  tag: Text,
  propsNeeded: ['isCompleted'],
  styles: ({ isCompleted }) => ({
    flex: '1',
    marginBottom: '1.25rem',
    opacity: isCompleted ? '0.5' : '1'
  })
});

export const ButtonContainer = superstyled({
  tag: Box,
  styles: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  }
});

export const IconContainer = superstyled({
  tag: Box,
  propsNeeded: ['isInProgress', 'isCompleted'],
  styles: ({ isInProgress, isCompleted, theme }) => ({
    height: '100%',
    alignItems: 'center',
    color: theme.palette.growth30.main,
    flex: '1',
    display: (!isInProgress && !isCompleted) ? 'none' : 'flex'
  })
});

export const CircleCheckIcon = superstyled({
  name: 'CircleCheckIcon',
  slot: 'CircleCheckIcon',
  propsNeeded: ['isCompleted'],
  tag: CheckCircleIcon,
  styles: ({ theme, isCompleted }) => ({
    color: isCompleted
      ? theme.palette.growth30.main
      : theme.palette.focus90.main,
    marginRight: '0.5rem'
  })
});

export const StyledWatchLaterIcon = superstyled({
  propsNeeded: ['isCompleted'],
  name: 'StyledWatchLaterIcon',
  slow: 'StyledWatchLaterIcon',
  tag: WatchLaterIcon,
  styles: ({ theme, isCompleted }) => ({
    color: isCompleted
      ? theme.palette.growth30.main
      : theme.palette.focus90.main,
    marginRight: '0.5rem'
  })
});

export const Status = superstyled({
  tag: Caption,
  styles: {
    fontWeight: '700'
  }
});

export const ContinueButton = superstyled({
  tag: Button,
  styles: {
    '&:before': {
      content: '""',
      cursor: 'pointer',
      display: 'block',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%'
    },
    position: 'static'

  }
});
